import React from 'react';
import './css/Documentations.css';

const DocumentationPage = () => {
  return (
    <div className="documentation-page">
      <h1 className="title">Ημερολόγιο Καλλιεργητών</h1>

      <section className="about">
        <h2>Αναπτύχθηκε από το SodaSense</h2>
        <p className="justified-text">Έργο με τίτλο «SodaSense: Προηγμένη διαχείριση δεδομένων μεγάλου όγκου με εφαρμογές στις μετακινήσεις, στο κλίμα και στη γεωργία» και με κωδικό ΟΠΣ 5060275.
          Εχει ενταχθεί στο Επιχειρησιακό Πρόγραμμα «Πελοπόννησος» στον Άξονα Προτεραιότητας «Ενίσχυση της ανταγωνιστικότητας, της ελκυστικότητας και της εξωστρέφειας της Περιφέρειας (ιδιαίτερα των ΜΜΕ), μετάβαση στην ποιοτική επιχειρηματικότητα με αιχμή την καινοτομία και αύξηση της περιφερειακής προστιθέμενης αξίας», που συγχρηματοδοτείται από Ευρωπαϊκό Ταμείο Περιφερειακής Ανάπτυξης (ΕΤΠΑ) στο πλαίσιο του Επιχειρησιακού Προγράμματος Πελοπόννησος 2014-2020</p>
      </section>

      <section className="getting-started">
        <h2>Για να έχετε πρόσβαση στο ηλεκτρονικό ημερολόγιο, ακολουθήστε τα παρακάτω βήματα:</h2>
        <ol>
          <li > Ως πρώτη ενέργεια που θα πρέπει να πραγματοποιήσετε είναι να πατήσετε το κουμπί "Είσοδος ή Εγγραφή" πάνω δεξιά.</li>
          <li> Πατώντας το κουμπί "Είσοδος ή Εγγραφή" εμφανίζεται μια φόρμα καταχώρησης στοιχείων (password και username) τα οποία θα πρέπει να συμπληρώσετε και να πατήσετε "Sign in".</li>
          <li> Στην περίπτωση που δεν έχετε δημιουργήσει λογαριασμό ακολουθήστε τα επόμενα βήματα.</li>
          <li> Για να μπορέσετε να δημιουργήσετε καινούργιο λογαριασμό (έχοντας πατήσει το κουμπί "Είσοδος ή Εγγραφή") θα χρειαστεί να πατήσετε στην επιλογή "Register".</li>
          <li> Στην συνέχεια, θα εμφανιστεί μια φόρμα καταχώρησης κάποιον στοιχείων, όπου και θα χρειαστεί να συμπληρώσετε.</li>
          <li> Τέλος, πατώντας το κουμπί "Register", δημιουργήται έναν καινούργιο λογαριασμό.</li>
          <li> Έχοντας εκτελέσει τις παραπάνω ενέργειες, έχετε πρόσβαση στο ηλεκτρονικό ημερολόγιο.</li>
        </ol>
      </section>

      <section className="features">
        <h2>Δυνατότητες του Ημερολογίου</h2>
        <ul>
          <li>
            <h3>Δημιουργία ενός συμβάντος</h3>
            <p>Σε αυτήν την επιλογή μπορείτε να προσθέσετε στοιχεία όπως, την <b>ημερομηνία</b>, τον τύπο της <b>καλλιέργιας</b>, την <b>περιοχή</b>, το <b>συμβάν</b> που προέκυψε, κάποια <b>σχόλια/παρατηρήσεις</b> καθώς και να επισυνάψετε μια <b>φωτογραφία</b>.</p>
          </li>
          <li>
            <h3>Προβολή αποθηκευμένων εικόνων</h3>
            <p>Σε αυτό το πεδίο, έχετε την δυνατότητα να δείτε τις φωτογραφίες που έχετε προσθέσει, αλλά και να φιλτράρετε τις φωτογραφίες με βάση την ημερομηνία.</p>
          </li>
          <li>
            <h3>Έλεγχος καιρού για τις επόμενες πέντε ημέρες</h3>
            <p>Σε αυτό το πεδίο, έχετε την δυνατότητα να ελέγξετε τον καιρό για τις επόμενες πέντε ημέρες με σκοπό την λήψη κατάλληλων αποφάσεων που χρειάζεται ανάλογα με την καρική συνθήκη. Πιο αναλυτικά, επιλέγοντας κάποια πειροχή μπορείτε να δείτε την <b>Ημερομηνία</b>, την	<b>Θερμοκρασία</b> (ελάχιστη και μέγιστη), τις	<b>Καιρικές Συνθήκες</b>, την	<b>Υγρασία</b>, τον	<b>Δείκτη UV</b>, την	<b>Ηλιακή Ακτινοβολία</b>, την <b>Ταχύτητα Ανέμου</b>, την ώρα <b>Ανατολής Ηλίου</b> καθώς και την ώρα <b>Δύσης Ηλίου</b>.</p>
          </li>
          <li>
            <h3>Προβολή διαγραμμάτων</h3>
            <p>Σε αυτό το πεδίο, υπάρχει η δυνατότητα προβολής πλήθους συμβάντων, με σκοπό την συνολική εικόνα των καταστάσεων που έχουν συμβεί στο χωράφι.</p>
          </li>
          <li>
            <h3>Εξαγωγή των καταγεγραμμένων συμβάντων σε αρχείο Excel</h3>
            <p>Σε αυτή την επιλογή, υπάρχει η δυνατότητα εξαγωγής σε αρχείο Excel τα αποθηκευμένα συμβάντα που έχουν καταχωρηθεί στο ηλεκτρονικό ημερολόγιο.</p>
          </li>
        </ul>
      </section>

      {/* <section className="benefits">
        <h2>FAQs</h2>
        <h3>1. How do I upload a file?</h3>
        <p>To upload a file, navigate to the File Management section and click on the "Upload" button. Select the file you want to upload from your local system and confirm the upload.</p>

        <h3>2. Can I share a file with another user?</h3>
        <p>Yes, you can share a file with another user. Simply select the file you want to share, choose the user you want to share it with, and grant the appropriate permissions.</p>

        <h3>3. How can I visualize my data?</h3>
        <p>You can visualize your data using the Data Visualization feature. Select the dataset you want to visualize, choose the desired chart type, and customize the chart options as needed.</p>
      </section> */}

      {/* <section className="benefits">
        <h2>Γιατί να χρησιμοποιήσετε το ηλεκτρονικό ημερολόγιο</h2>
        <p>Η χρήση ενός ηλεκτρονικού ημερολογίου αποτελεί έναν εύκολο και αποτελεσματικό τρόπο για τον αγρότη να καταγράψει,
          παρακολουθήσει και αναλύσει τα δεδομένα της γεωργικής του δραστηριότητας.</p>
        <ul>
          <li>Καταγραφή συμβάντων: Το ηλεκτρονικό ημερολόγιο επιτρέπει στον αγρότη να καταγράφει τα συμβάντα που συμβαίνουν στο χωράφι του.</li>
          <li>Προβολή φωτογραφιών: Ο αγρότης μπορεί να ανεβάσει φωτογραφίες από το χωράφι του στο ηλεκτρονικό ημερολόγιο, γεγονός που του επιτρέπει
            να παρακολουθεί την πρόοδο των φυτών ή την κατάσταση των καλλιεργειών του.</li>
          <li>Πρόγνωση καιρού: Το ηλεκτρονικό ημερολόγιο μπορεί να παρέχει πληροφορίες για τον καιρό σε συγκεκριμένες περιοχές, βοηθώντας τον αγρότη
            να προγραμματίσει τις δραστηριότητές του με βάση τις καιρικές συνθήκες.</li>
          <li>Εξαγωγή σε αρχείο Excel: Το ηλεκτρονικό ημερολόγιο επιτρέπει την εξαγωγή των καταγεγραμμένων συμβάντων σε αρχείο Excel, προσφέροντας
            τη δυνατότητα ανάλυσης και επεξεργασίας των δεδομένων με περισσότερες επιλογές.</li>
        </ul>
      </section> */}
      <footer className="footer">
        <p>
          Copyright © 2023 SodaSense | Powered by <a href="https://sodasense.uop.gr/">SodaSense</a>
        </p>
      </footer>
    </div>
  );
};

export default DocumentationPage;
